import { colors, TColors } from '../Badge';

export const categoryToColorMapper: Record<string, TColors> = {
  frontend: colors[0] as TColors,
  backend: colors[1] as TColors,
  ai: colors[7] as TColors,
  api: colors[11] as TColors,
  cloud: colors[5] as TColors,
  qa: colors[8] as TColors,
  database: colors[4] as TColors,
  devops: colors[2] as TColors,
  security: colors[10] as TColors,
  payments: colors[12] as TColors,
  crm: colors[13] as TColors,
  cms: colors[6] as TColors,
  ecommerce: colors[14] as TColors,
  uiux: colors[3] as TColors,
  collaboration: colors[9] as TColors,
};

export const categoryMapper = {
  [`Frontend`]: `frontend`,
  [`Backend`]: `backend`,
  [`AI`]: `ai`,
  [`API`]: `api`,
  [`Cloud`]: `cloud`,
  [`QA/Testing`]: `qa`,
  [`Database`]: `database`,
  [`DevOps`]: `devops`,
  [`Security`]: `security`,
  [`Payments`]: `payments`,
  [`CRM`]: `crm`,
  [`CMS`]: `cms`,
  [`Ecommerce`]: `ecommerce`,
  [`UI/UX`]: `uiux`,
  [`Collaboration`]: `collaboration`,
};
